<template>
    <div>
        <div class="hts-categorys-index-type">
            <div class="hts-categorys-index-type__container">
                <div class="mt-5">
                    <div class="box-button">
                        <div class="">
                            <hts-form-button
                                type="submit"
                                color="main"
                                icon-name="hi-plus-circle-icon"
                                icon-position="right">
                                {{ $t('labels.addcategory') }}
                            </hts-form-button>
                        </div>
                    </div>
                </div>
                <div class="body">
                    <div>
                        <div class="shadow border-b border-gray-200 sm:rounded-lg">
                            <type-category v-loading="isLoading" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
/*
  TODO: API data categorys type
  handle loading page
*/

let timeOut: any
const isLoading = ref(true)
const time = 1000
const handleLoading = () => {
  clearTimeout(timeOut)
  timeOut = setTimeout(() => {
    isLoading.value = false
  }, time)
}
handleLoading()
/* loading page */
</script>
